import { FunctionComponent } from 'react';
import { Button, ButtonGroup } from '@shopify/polaris';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
`;

export interface ToggleProps {
  label: string;
  isActive: boolean;
  activeText: string;
  inActiveText: string;
  onToggle(active: boolean): void;
}

const Toggle: FunctionComponent<ToggleProps> = (props) => {
  const { activeText, inActiveText, isActive, label, onToggle } = props;

  return (
    <Container>
      <label>{label}</label>
      <ButtonGroup segmented>
        <Button primary={isActive} onClick={() => onToggle(true)}>
          {activeText}
        </Button>
        <Button destructive={!isActive} onClick={() => onToggle(false)}>
          {inActiveText}
        </Button>
      </ButtonGroup>
    </Container>
  );
};

export default Toggle;
